var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-modal m-modal--inline"},[_c('div',{staticClass:"m-modal__inner"},[_c('h3',[_vm._v(_vm._s(_vm.result.question))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.result.answer)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }